import type { Alert, UploadLevelAlerts } from "../../zodios/apiDefinitions/uploads";

export interface ValidationItem {
  row: number | null;
  field: string;
  message: string;
}

function flattenAlerts(alerts: Alert[]): { errors: ValidationItem[]; warnings: ValidationItem[] } {
  const errors: ValidationItem[] = [];
  const warnings: ValidationItem[] = [];

  for (const alert of alerts) {
    for (const e of alert.errors.errors) {
      errors.push({ row: alert.row_number, field: e.field, message: e.message });
    }
    for (const w of alert.errors.warnings) {
      warnings.push({ row: alert.row_number, field: w.field, message: w.message });
    }
  }

  return { errors, warnings };
}

// V2 uploads (PricingPlanBulkUploadV2) store upload-level alerts as a dict
// `{errors, warnings}` since per-row data lives in PricingPlanUploadRow. V1
// (BulkProcessor) stores an array of per-row alerts. This helper normalizes both.
export function flattenUploadAlerts(upload: {
  alerts?: Alert[] | UploadLevelAlerts | null;
  warnings?: Alert[] | null;
}): { errors: ValidationItem[]; warnings: ValidationItem[] } {
  const errors: ValidationItem[] = [];
  const warnings: ValidationItem[] = [];

  if (upload.alerts && !Array.isArray(upload.alerts)) {
    for (const e of upload.alerts.errors) errors.push({ row: null, field: e.field, message: e.message });
    for (const w of upload.alerts.warnings) warnings.push({ row: null, field: w.field, message: w.message });
  }

  const v1Alerts = [...(Array.isArray(upload.alerts) ? upload.alerts : []), ...(upload.warnings ?? [])];
  if (v1Alerts.length > 0) {
    const v1 = flattenAlerts(v1Alerts);
    errors.push(...v1.errors);
    warnings.push(...v1.warnings);
  }

  return { errors, warnings };
}
